module.exports = __webpack_public_path__ + "img/km.38d64550.svg";